import { useTollingAdminAccessQuery } from 'queries/useTollingAdminAccessQuery';
import { useEffect } from 'react';
import useAuthStore from 'store/authStore';

function PollingTollingAdminAccess() {
  const { data } = useTollingAdminAccessQuery();
  const { setTollingAdminAccessObject } = useAuthStore();
  useEffect(() => {
    if (data) {
      setTollingAdminAccessObject(data);
    }
  }, [data, setTollingAdminAccessObject]);
  return null;
}

export default PollingTollingAdminAccess;
